import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = loading
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem("dft_token");
        if (!token) {
            setUser(false);
            setReady(true);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => {
                localStorage.removeItem("dft_token");
                setUser(false);
            })
            .finally(() => setReady(true));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("dft_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const register = async (name, email, password, companyName) => {
        const { data } = await api.post("/auth/register", { name, email, password, company_name: companyName });
        localStorage.setItem("dft_token", data.token);
        // Inject company onto user since API returns it as separate field
        const userWithCompany = { ...data.user, company: data.company };
        setUser(userWithCompany);
        return userWithCompany;
    };

    const logout = () => {
        localStorage.removeItem("dft_token");
        setUser(false);
        window.location.href = "/login";
    };

    const hasSurface = (surface) => {
        if (!user) return false;
        if (user.role === "super_admin") return true;
        const company = user.company || {};
        // partner_comp billing_exempt bypasses all surface gates
        if (company.plan_type === "partner_comp" && company.billing_exempt) return true;
        return (company.subscribed_surfaces || []).includes(surface);
    };

    return (
        <AuthContext.Provider value={{ user, ready, login, register, logout, hasSurface }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
